// Reading any failure the same way (spec/08 §2.6, 2026-10-12).
//
// A screen that shows why something was refused needs the same few facts whatever raised it: the problem's code, its
// status, the server's own `detail`, the field errors of a validation failure, and the reference to quote to support.
// `describeError` reads them off a problem document (`ApiProblemError`), a better-auth refusal (`ApiAuthError`), a
// transport failure or anything else, so no screen compares codes by hand or falls back to a bare "refused".
import { ApiAuthError, ApiProblemError, ApiTransportError } from "./problem.js";
const NOTHING = { code: undefined, status: undefined, detail: undefined, fields: [], requestId: undefined, total: undefined, activeSession: undefined };
/** `wallet-disabled` → `wallet_disabled`: the station relays a problem's code as a kebab-case slug. */
export function codeFromSlug(value) {
    return value.trim().replaceAll('-', '_');
}
export function describeError(error) {
    if (error instanceof ApiProblemError) {
        return {
            kind: 'problem',
            code: error.code,
            status: error.status,
            detail: error.problem.detail,
            fields: error.fieldErrors,
            requestId: error.requestId,
            total: error.problem.total,
            activeSession: error.problem.activeSession,
        };
    }
    if (error instanceof ApiAuthError) {
        return { ...NOTHING, kind: 'auth', code: error.code, status: error.status, detail: error.message, requestId: error.requestId };
    }
    if (error instanceof ApiTransportError) {
        return { ...NOTHING, kind: 'transport', status: error.status, requestId: error.requestId };
    }
    return { ...NOTHING, kind: 'unknown' };
}
/**
 * A refusal the station relayed to the kiosk (`intent/ack` with status `rejected`): its message is the problem's code
 * as a kebab-case slug (`cash-needs-shift`), possibly inside a longer string, or one of the station's own words
 * (`station-timeout`, `start-failed`). Pass the codes the caller can tell apart; the first one found wins.
 */
export function describeStationRefusal(message, knownCodes) {
    if (message === undefined || message === '')
        return { ...NOTHING, kind: 'station' };
    const found = [...knownCodes].sort((a, b) => b.length - a.length).find((code) => message.includes(code.replaceAll('_', '-')) || message.includes(code));
    return { ...NOTHING, kind: 'station', code: found === undefined ? codeFromSlug(message) : found };
}
/** The problem field errors for one request-body field, matched on its dotted path (or its last segment). */
export function fieldErrorFor(described, field) {
    return described.fields.find((entry) => entry.field === field) ?? described.fields.find((entry) => entry.field.split('.').at(-1) === field);
}
//# sourceMappingURL=describe.js.map